import { Injectable } from '@angular/core';
import { RoutePathBuilder } from '@ngspot/route-path-builder';

@Injectable()
export class RoutesForReceiving extends RoutePathBuilder {
    dashboard() {
        return this.url('');
    }

    process() {
        return this.url('process');
    }

    processForOrder(orderNumber: string) {
        return this.urlFromCommands(['process'], {
            queryParams: { orderNumber },
        });
    }

    rma() {
        return this.url('rma');
    }
}
